import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AshleyHomesComponent } from './ashley-homes/ashley-homes.component';

const routes: Routes = [
  {
    path: "main",
    component: AshleyHomesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FurnitureProtectionRoutingModule { }
